import styled from 'styled-components';
import { useMemo } from 'react';
import Icon, { ICON_USER } from '~/components/icon/index';
import breakpoint from '~/utils/style-utils';
import { Button } from '@comeon/ui';
import useTranslations from '~/components/translation/use-translations';
import Loading from '~/components/misc/loading';

const SeatsWrapper = styled.div`
	display: flex;
	gap: 1.67px;
	flex-grow: 1;
	justify-content: center;
	align-items: center;
	height: 36px;
	padding: 6px 0;
	position: relative;
	${breakpoint.lg`
		gap: 9px;
  `}
`;

const IconWrapper = styled.div<{ filled: boolean }>`
	height: 20px;
	width: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: ${({ filled }) => (filled ? '.15' : '1')};
	z-index: 1;
	cursor: pointer;
`;

const TableFullButton = styled(Button)`
	border-radius: 6px;
	background-color: var(--main-primary);
	color: var(--main-on-primary);
	font: var(--small-bold);
	padding: 5px;
`;

interface ISeats {
	activeSeats: number[];
	clickHandler: (event: React.MouseEvent<HTMLElement>, index?: number) => void;
}

const textKeys = ['BLACKJACK_TABLE_FULL'];

const Seats: React.FC<ISeats> = ({ activeSeats, clickHandler }) => {
	const { translations: t, isLoadingTranslations } = useTranslations(textKeys);

	const seats = useMemo(() => {
		return Array.from({ length: 7 }, (_, index) => (
			<IconWrapper key={index} filled={activeSeats?.includes(index)} onClick={e => clickHandler(e, index + 1)}>
				<Icon type={ICON_USER} width="13" height="13" />
			</IconWrapper>
		));
	}, [clickHandler, activeSeats]);

	const isTableFull = activeSeats?.length >= 7;

	if (isLoadingTranslations) {
		return <Loading />;
	}

	return (
		<SeatsWrapper>
			{isTableFull ? (
				<TableFullButton
					onClick={e => {
						clickHandler(e, undefined);
					}}
				>
					{t.BLACKJACK_TABLE_FULL}
				</TableFullButton>
			) : (
				seats
			)}
		</SeatsWrapper>
	);
};

export default Seats;
